import { Clients, ClientWithoutCoClient } from "@modules/client/types";
import { JSONSchemaType } from "ajv";
import { states } from "@modules/tasks/data/states.json";

export const BASE_URL = "/v1/clients";
export const clientIntakeSchema: JSONSchemaType<Clients> = {
  $id: "https://formefinancial.com/schemas/clientIntake.json",
  type: "object",
  properties: {
    client: {
      type: "object",
      $ref: "client.json",
    },
    coClient: {
      type: "object",
      $ref: "client.json",
    },
  },
  required: ["client", "coClient"],
};

export const soloClientIntakeSchema: JSONSchemaType<ClientWithoutCoClient> = {
  $id: "https://formefinancial.com/schemas/clientIntake.json",
  type: "object",
  properties: {
    client: {
      type: "object",
      $ref: "client.json",
    },
  },
  required: ["client"],
};

export const clientSchema = {
  $id: "https://formefinancial.com/schemas/client.json",
  type: "object",
  properties: {
    FIRST_NAME: { type: "string", minLength: 1, errorMessage: "Required" },
    LAST_NAME: { type: "string", minLength: 1, errorMessage: "Required" },
    EMAIL: {
      type: "string",
      format: "email",
      errorMessage: "Must be a valid email address",
    },
    PHONE_NUMBER: {
      type: "string",
      // pattern: "^\\+1 (\\d{3}) \\d{3} \\d{4}$", // US E.164
      pattern: "\\+1 \\(\\d{3}\\) \\d{3} \\d{4}",
      errorMessage: "Must be a valid US phone number",
    },
    SSN: {
      type: "string",
      pattern: "\\d{3}-\\d{2}-\\d{4}",
      errorMessage: "Must be a valid SSN in the format xxx-xx-xxxx",
    },
    DOB: {
      type: "string",
      pattern: "\\d{2}/\\d{2}/\\d{4}",
      errorMessage: "Must be a valid date in the format mm/dd/yyyy",
    },
    DRIVER_LICENSE_NUMBER: {
      minLength: 1,
      type: "string",
      errorMessage: "Must be a valid driver's license number",
    },
    DRIVER_LICENSE_STATE: {
      minLength: 1,
      type: "string",
      enum: states,
      errorMessage: "Must be a valid state (e.g. NY, CA)",
    },
    DRIVER_LICENSE_EXP: {
      type: "string",
      pattern: "\\d{2}/\\d{2}/\\d{4}",
      errorMessage: "Must be a valid expiration date in the format mm/dd/yyyy",
    },
    OCCUPATION: { type: "string", nullable: true },
    EMPLOYMENT_STATUS: {
      nullable: true,
      type: "string",
      enum: [
        "Employed",
        "Self-employed",
        "Out of work",
        "Homemaker",
        "Student",
        "Retired",
        "Unable to work",
      ],
      errorMessage: "Please select your current employment status",
    },
    EMPLOYER_NAME: { type: "string", nullable: true },
    ADDRESS_STREET: {
      type: "string",
      minLength: 1,
      errorMessage: "Please enter your street address",
    },
    ADDRESS_STREET_2: { type: "string", nullable: true },
    ADDRESS_CITY: {
      type: "string",
      minLength: 1,
      errorMessage: "Please enter your city",
    },
    ADDRESS_STATE: {
      type: "string",
      minLength: 1,
      enum: states,
      errorMessage: "Must be a valid state (e.g. NY, CA)",
    },
    ADDRESS_ZIP: {
      type: "string",
      pattern: "\\d{5}",
      errorMessage: "Must be a valid 5-digit ZIP code",
    },
    MAILING_ADDRESS_STREET: { type: "string", nullable: true },
    MAILING_ADDRESS_STREET_2: { type: "string", nullable: true },
    MAILING_ADDRESS_CITY: { type: "string", nullable: true },
    MAILING_ADDRESS_STATE: { type: "string", nullable: true, enum: states },
    MAILING_ADDRESS_ZIP: {
      type: "string",
      nullable: true,
      pattern: "^\\d{0,5}$",
      errorMessage: "Must be a valid 5-digit ZIP code",
    },
    HAS_FINRA_ASSOCIATION: { type: "boolean", nullable: true },
  },
  required: [
    "FIRST_NAME",
    "LAST_NAME",
    "EMAIL",
    "PHONE_NUMBER",
    "SSN",
    "DOB",
    "DRIVER_LICENSE_NUMBER",
    "DRIVER_LICENSE_STATE",
    "DRIVER_LICENSE_EXP",
    "ADDRESS_STREET",
    "ADDRESS_CITY",
    "ADDRESS_STATE",
    "ADDRESS_ZIP",
  ],
};
